import React, { useContext, useState } from "react"
import { DF_LO0003Context } from "../context"
import { Row } from "reactstrap"
import TableSimple from "../../../components/Dynamic/TableSimple"
import ModalIframePage from "../../../components/Common/ModalIframePage"

const PROC_NAME = "FRONT_Workspace_DF_LO0003_Tabela_Grid_V16"

export default function GridBody() {
  const {
    paramsOnFilter,
    triggerOnFilter,
    setTriggerOnFilter,
    inputGlobalSearchValue,
    setFilteredData,
    userProfile
  } = useContext(DF_LO0003Context)

  const [triggerType, setTriggerType] = useState('')
  const [openModalVisualization, setOpenModalVisualization] = useState(false)

  const handleTriggers = (trigger) => {
    setOpenModalVisualization(true)
    setTriggerType(trigger)
  }

  return (
    <React.Fragment>
      <Row>
        <TableSimple
          dataKey={"ID_Arquivo"}
          procName={PROC_NAME}
          procParams={`[
            ${userProfile.ID_Usuario},
            "pt-BR",
            1,
            9999,
            "CT",
            "<#Filtro_Data_Inicio#>",
            "<#Filtro_Data_Termino#>",
            "<#Filtro_ID_Empresa_Origem#>",
            "<#Filtro_ID_Empresa_Destino#>",
            "<#Filtro_ID_Empresa_Remetente#>",
            "<#Filtro_Numero_Documento#>",
            "<#Filtro_Status_Documento#>",
            "<#Filtro_Status_Validacao#>",
            "<#Filtro_Status_Leitura#>",
            "<#Filtro_Tomador#>",
            "<#Filtro_Tipo_Documento_Transporte#>",
            "<#Filtro_ID_Categorias#>",
            "<#Filtro_Documento_Relacionado#>",
            "<#Filtro_PreFiltro#>"
          ]`}
          columnsList={
            [
              {
                "field":"Status",
                "header":"Status",
                "width": '5%',
                "hasImage": true,
              },
              {
                "field":"Data_Processamento",
                "header":"Data Process.",
                "sort": true,
              },
              {
                "field":"Tipo_Frete",
                "header":"Tipo",
                "sort": true,
              },
              {
                "field":"DOC",
                "header":"Doc",
                "sort": true,
              },
              {
                "field":"NF",
                "header":"NF",
                "sort": true,
              },
              {
                "field":"Transportadora",
                "header":"Transportadora",
                "sort": true,
                "hasImage": true,
              },
              {
                "field":"Destino",
                "header":"Destino",
                "hasImage": true,
                "sort": true,
                "align": "center"
              },
              {
                "field":"Planta",
                "header":"Planta",
                "sort": true,
              },
              {
                "field":"Fornecedor",
                "header":"Fornecedor",
                "sort": true
              },
              {
                "field":"Valor_Total",
                "header":"Valor",
                "sort": true,
                "width": '90px'
              },
              {
                "field":"Recebimento",
                "header":"Receb.",
                "width": '90px'
              },
              {
                "field":"Coluna_Funcoes",
                "header":"",
                "width": '5%',
                "hasImage": true
              },
              ]
          }
          inputSearchValue={inputGlobalSearchValue}
          callbackTriggers={handleTriggers}
          enableDataSharing={true}
          enableMinHeight={true}
          onFilteredDataChange={setFilteredData}
          triggerOnFilter={triggerOnFilter}
          setTriggerOnFilter={setTriggerOnFilter}
          paramsOnFilter={paramsOnFilter}
        />

        <ModalIframePage
          openModal={openModalVisualization}
          onClosed={(isReloadPage) => {
            if (isReloadPage) setTriggerOnFilter(true)
            setOpenModalVisualization(false)
          }}
          triggerType={triggerType}
        />

      </Row>
    </React.Fragment>
  )
}
